module.exports = __webpack_public_path__ + "img/logo-notyreplus.1075514c.png";